import { render, staticRenderFns } from "./ConciergerieForm.vue?vue&type=template&id=788d6970&"
import script from "./ConciergerieForm.vue?vue&type=script&lang=js&"
export * from "./ConciergerieForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports